import _ from "lodash";
import * as React from "react";
import { formatDate, formatDateTime } from "../../classes/DateHelper";
import { htmlToText } from "../../classes/StringHelper";
import { IConfig } from "../../Config";
import { ViewType } from "../../NewsroomView";
import { ConfirmDialog } from "../Dialogs";

interface IProps {
    activeCategories: any[];
    activeTags: any[];
    config: IConfig;
    headingLevel: string;
    isAdmin: boolean;
    isViewingArchivedItems: boolean;
    layoutStyle: string;
    onDelete: (newsId: string, isDeleted: boolean, isPermanent: boolean) => void;
    onSwitchView: (view: ViewType, newsId?: string) => void;
    page: number;
    posts: any[];
    showAuthor: boolean;
    writableFeedIds: string[];
}

interface IState {
    isConfirmingToUnarchive: boolean;
    isConfirmDeleteOpen: boolean;
    isPermanentDelete: boolean;
    popupMessage: string;
    selectedNewsId: string | null;
}

class Grid extends React.Component<IProps, IState> {
    public constructor(props) {
        super(props);
        this.state = {
            isConfirmDeleteOpen: false,
            isConfirmingToUnarchive: false,
            isPermanentDelete: false,
            popupMessage: "",
            selectedNewsId: null,
        };
    }

    public render() {
        return (
            <div className="NR_posts NR_pGrid">
                {this.visiblePosts.length > 0 ?
                    _.map(_.chunk(this.visiblePosts, 3), (posts, index) =>
                    (<ul
                        key={`row-${index}`}
                        style={{ display: "flex", flexDirection: this.props.layoutStyle === "list" ? "column" : "row" }}
                        className={`${this.props.layoutStyle === "list" ? "list" : ""}`}
                    >
                        {_.map(posts, (post) =>
                        (<li className="NR_item" key={post.newsId}>
                            <div>
                                {(this.props.isAdmin && post.feeds.some((f) => this.props.writableFeedIds.includes(f.feedId))) ?
                                <div className="NR_editItem">
                                    <button
                                        className="NR_itemLink CMS_button CMS_bSquare CMS_bWarn"
                                        title="Edit"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.onEditPost(post.newsId);
                                        }}
                                    >
                                        <em className="fa fa-pencil"></em>
                                    </button>&nbsp;
                                    <button
                                        className="NR_itemLink CMS_button CMS_bSquare CMS_bAction"
                                        title={post.deleted ? "Unarchive" : "Archive"}
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            if (!post.deleted) {
                                                this.setState({ popupMessage:  "Are you sure you want to archive this post?"});
                                                this.setState({ selectedNewsId: post.newsId, isConfirmDeleteOpen: true, isPermanentDelete: false });
                                            } else {
                                                this.setState({ popupMessage: "Are you sure you want to unarchive this post?"});
                                                this.setState({ selectedNewsId: post.newsId, isConfirmDeleteOpen: true, isConfirmingToUnarchive: true, isPermanentDelete: false });
                                            }
                                        }}
                                    >
                                        <em className={!post.deleted ? "fa fa-archive" : "fa fa-eject"}></em>
                                    </button>
                                    {post.deleted ?
                                        <>&nbsp;
                                            <button
                                                className="NR_itemLink CMS_button CMS_bSquare CMS_bCancel"
                                                title="Delete"
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    this.setState({ popupMessage:  "Are you sure that you want to permanently delete this post?"});
                                                    this.setState({ selectedNewsId: post.newsId, isConfirmDeleteOpen: true, isPermanentDelete: true });
                                                }}
                                            >
                                                <em className="fa fa-trash"></em>
                                            </button></> : null
                                    }
                                </div> : null}
                                {this.title(post)}
                                {!_.isEmpty(post.featuredImage) ? <div
                                    className="NR_image"
                                    aria-label={post.featuredImageCaption}
                                    style={{ background: `url('${_.trimEnd(this.props.config.cdnLocation, "/")}${post.featuredImage}') center center / cover no-repeat` }}
                                ></div> : null}
                                {
                                    (this.isFuturePost(post.scheduledDate)) ?
                                    <div className="NR_publishDate">{this.futurePostMessage(post.scheduledDate)} {formatDateTime(post.scheduledDate)} {this.props.showAuthor ? <>- by {post.author}</> : null}</div>
                                   :
                                    <div className="NR_publishDate">{formatDate(post.scheduledDate)} {this.props.showAuthor ? <>- by {post.author}</> : null}</div>
                                }
                                <div className={"NR_summary " + (_.isEmpty(post.featuredImage) ? "truncate-long" : "truncate")}>
                                    {_.truncate(htmlToText(post.summary), {
                                        length: 255,
                                        separator: /,? +/,
                                    })}
                                </div>
                            </div>
                            <div>
                                <button
                                    className="NR_itemLink CMS_button CMS_bAction"
                                    title={`Read more about '${post.title}'`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.onReadPost(post.friendlyUrlName);
                                    }}
                                >
                                    Read more
                                </button>
                            </div>
                        </li>),
                        )}
                    </ul>),
                    ) : <p style={{ textAlign: "center" }}>No news items found for this portlet</p>}
                <ConfirmDialog
                    isOpen={this.state.isConfirmDeleteOpen}
                    message={this.state.popupMessage}
                    callBack={async (value) => {
                        this.setState({ isConfirmDeleteOpen: false });
                        if (value) {
                            await this.props.onDelete(this.state.selectedNewsId, !this.state.isConfirmingToUnarchive, this.state.isPermanentDelete);
                            this.setState({ selectedNewsId: null, isConfirmingToUnarchive: false });
                        }
                    }}
                />
            </div>
        );
    };

    private title(post) {
        const pin =  post.feeds.some((f) => f.pinToTop === true)  ? <i className="fa fa-thumb-tack pinned"></i> : null;
        const className = "NR_title CMS_title CMS_T6";
        switch ((this.props.headingLevel || "").toLowerCase()) {
            case "a":
                return <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        this.onReadPost(post.friendlyUrlName);
                    }}
                >
                    {pin} {post.title}
                </a>;
            case "div":
                return <div className={className}>{pin} {post.title}</div>;
            case "span":
                return <span className={className}>{pin} {post.title}</span>;
            case "h1":
                return <h1 className={className}>{pin} {post.title}</h1>;
            case "h2":
                return <h2 className={className}>{pin} {post.title}</h2>;
            case "h3":
            default:
                return <h3 className={className}>{pin} {post.title}</h3>;
        }
    }

    private get visiblePosts() {
        const posts = [];
        _.forEach(this.props.posts, (post) => {
            if ((_.isEmpty(this.props.activeCategories) && _.isEmpty(this.props.activeTags))
                || (_.intersection(this.props.activeCategories, _.map(post.categories, (category) => category.categoryId)).length > 0
                    || _.intersection(this.props.activeTags, _.map(post.tags, (tag) => tag.tag)).length > 0)) {
                posts.push(post);
            }
        });
        return posts;
    }

    private onReadPost(friendlyUrl: string) {
        this.props.onSwitchView(ViewType.Details, friendlyUrl);
    }

    private onEditPost(newsId: string) {
        this.props.onSwitchView(ViewType.EditForm, newsId);
    }

    private futurePostMessage(scheduledDate) {
        return this.isFuturePost(scheduledDate) ? "This article will be published at " : "";
    }

    private isFuturePost(scheduledDate): boolean {
        const nowTime = new Date().getTime();
        // remove quote mark from date string
        scheduledDate = scheduledDate.replace(/['"]+/g, "");
        // Add z to mark as UTC time
        scheduledDate = scheduledDate.toLowerCase().endsWith("z") ? scheduledDate : `${scheduledDate}Z`;
        return  Date.parse(scheduledDate) > nowTime;
    }
};

export default Grid;
